<div class="{{brand}} {{backgroundType}}">
  <div class="gb-align-center gb-align-center-mobile gb-headline1 pb-8 container">
    {{subHeader}}
  </div>
  <a-la-carte-section-gm-web-shop 
    [productBlock]="products" 
    [brand]="brand"
    [backgroundType]="backgroundType"
    [pageType]="'my plans'"
    [aemYear]="year"
    (aLaCartEmitter)="aLaCartClick($event)"
  ></a-la-carte-section-gm-web-shop>
  <webu-plan-offer-banner [linkCheck] = "'button'"></webu-plan-offer-banner>
</div>
